<template>
  <section>
    <div>
      <span>
        <title class="display-inline-block body1">1. Download</title>
        <span class="display-inline-block install-button">
          <p
            class="display-block download-instr complete cursor-pointer"
            @click.prevent="downloadPackage"
            v-if="osDownloadProgress.status === 'success'"
          >
            Download Complete!
            <i class="material-icons done">done</i>
          </p>
          <p v-else class="display-block download-instr cursor-pointer" @click.prevent="downloadPackage">
            confluera agent installer
          </p>
          <el-progress
            class="display-block"
            v-if="$_.indexOf(['start', 'loading'], osDownloadProgress.status) > -1"
            :percentage="osDownloadProgress.percentage"
            :show-text="false"
          ></el-progress>
        </span>
      </span>
    </div>
    <div>
      <span>
        <title class="display-block body1">2. Installation</title>
      </span>
      <br />
      <div>
        <span>
          <title class="display-block body1">Extract Package</title>
          <p>
            {{
              `Extract trailblazer-packages-${environment}-${customerName}.zip to a directory accessible by the installation target.`
            }}
          </p>
        </span>
      </div>
      <br />
      <div>
        <span>
          <title class="display-block body1">Extract Credentials</title>
          <p>{{ `Extract trailblazer-config-${environment}-${customerName}.zip to C:\ProgramData\Trailblazer.` }}</p>
          <p>Ensure the .pem and .conf files are in C:\ProgramData\Trailblazer and not a subdirectory!</p>
          <br />
          <img src="/static/images/instructions/extract_credentials.png" alt />
        </span>
      </div>
      <br />
      <div>
        <span>
          <title class="display-block body1">Run Installer</title>
        </span>
        <p>Run Trailblazer*.msi installer. Accept EULA and click Install.</p>
        <img src="/static/images/instructions/installer.png" alt />
      </div>
      <br />
    </div>
    <div>
      <span>
        <title class="display-block body1">3. Check</title>
        <p>Check to ensure it is running via Services:</p>
      </span>
      <img src="/static/images/instructions/validation.png" alt />
    </div>
    <br />
    <div>
      <span>
        <title class="display-block body1">Removal</title>
        <p>To remove go to Add/Remove Programs. Find Trailblazer and Click uninstall.</p>
      </span>
      <img src="/static/images/instructions/uninstall_msi.png" alt />
    </div>
    <br />
    <br />
    <br />
  </section>
</template>

<script>
import OsInstallInstructions from '@/components/os-template/OsInstallInstructions'
export default {
  name: 'WindowsInstructions',
  extends: OsInstallInstructions
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/text.css';

title {
  color: var(--denim-700) !important;
  font-weight: bold !important;
}

pre {
  white-space: pre-line;
}

.install-button {
  vertical-align: middle;
}

.download-instr {
  line-height: 28px;
  padding: 4px;
  color: var(--denim-900);
  background-color: var(--denim-50);
  border: 1px solid var(--denim-900);

  &.complete {
    color: var(--shamrock-600);
    background-color: var(--shamrock-50);
    border: 1px solid var(--shamrock-600);
  }

  .done {
    vertical-align: text-bottom;
    margin-left: 25px;
  }
}

img {
  display: block;
  border: 1px solid var(--border-color);
}
</style>



// WEBPACK FOOTER //
// src/components/os-template/WindowsInstructions.vue